<template>
  <div>
      
    <div class="navbar-fixed">
      <nav fixed>
        <div class="nav-wrapper">
          <!-- <a href="/" class="brand-logo"> -->
          <router-link to="/" class="brand-logo">
            <div id="zapy-logo" class="logo-size"></div>
            </router-link>
          <!-- </a> -->
  
          <ul class="right hide-on-med-and-down nav-content-position">
            <li v-if="currentpage === 'home'">
              <!-- <a href="/partner">Become a Partner</a> -->
             
                <router-link to="/partner" class="nav-link-retangle">Become a Partner</router-link>
             
            </li>
            <li v-else>
              <!-- <a href="/partner">Become a Partner</a> -->
             
                <router-link to="/" class="nav-link hover-1">Overview</router-link>
             
            </li>
            <li>
              <a href="#contactus" class="nav-link hover-1">Contact Us</a>
              <!-- <router-link to="/#contactus">Contact Us</router-link> -->
            </li>
          </ul>
          <a id="mobileMenu" class="right sidenav-trigger" @click="visible = !visible" ><i class="material-icons unselectable">menu</i></a>
        </div>
      </nav>
    </div>

    <div >
    <ul id="mobile-dropdown" class="dropdown-content mobile-dropdown-show" v-if="visible"  ref="dropdownMenu" >
      <li v-if="currentpage === 'home'">
          <router-link to="/partner">
            <div  class="mobile-dropdown-partner" >
                Become a Partner
            </div>
          </router-link> 
      </li>
      <li v-else>
        <router-link to="/">
               <div  class="mobile-dropdown-partner" >
                  Overview
               </div>
        </router-link>           
      </li>
      <li style="text-align:center;" >
          <a href="#contactus" @click="visible = !visible">Contact Us</a>          
          <!-- <router-link to="/#contactus">Contact Us</router-link> -->
      </li>
    </ul>
  </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["currentpage"],
  data() {
    return {
      visible: false
    };
  },
  methods: {
    documentClick(e) {
      e.stopPropagation();
      let el = this.$refs.dropdownMenu;
      let target = e.target;

      if (el !== target && el !== undefined) {
        this.visible = false;
      }
    }
  },
  created() {
    document.addEventListener("click", this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick)
  }
};
</script>
